import { PaymentElement } from "@stripe/react-stripe-js";
import { useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { Box } from "@mui/system";
import { Button, Grid } from "@mui/material";
import { callApi } from "../../common/api";

export default function CheckoutForm(props) {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isButton,setIsButton]=useState(false)
setTimeout(() => {
  setIsButton(true)
}, 1500);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    setIsProcessing(true);
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/startUpDetails`,
      },
      redirect: "if_required",
      // billing_address_collection: "required"
    });
    if (error) {
      if (error?.type === "card_error" || error?.type === "validation_error") {
        setMessage(error.message);
      }
      else {
        setMessage("An unexpected error occured.");
      }
    }
    else {
      let obj = {
        startupId: props?.startupId,
        paymentId: paymentIntent.id,
        // amount: paymentIntent.amount / 100
        amount: paymentIntent.amount
        
      }
      const response = await callApi("post", "investor/payment", obj)
      props.setPage(2)
    }
    setIsProcessing(false);
  };

  return (
    <div id="divv" style={{ color: "white" }}>
      <form id="payment-form" style={{ color: "white" }} onSubmit={handleSubmit}>
        <PaymentElement id="payment-element" />
        <br></br>
        <Box sx={{ display: "flex", paddingTop: "10px" }}>
          <Grid item xs={12} className="payment">
            {elements && isButton &&
              <Button disabled={isProcessing || !stripe || !elements} id="buttons" onClick={handleSubmit}>
                {isProcessing ? "Processing ... " : `Pay: ${props.amount / 100} ${(props.currency).toUpperCase()}`}
              </Button>
            }
          </Grid>
        </Box>
        {message && <div id="payment-message">{message}</div>}
      </form>
      <div id="address-warning" style={{ marginTop: "10px", color: "red" }}>
        Payment will not be processed until you add your address in your profile. Please go to Edit Profile to update your address.
      </div>
    </div>
  );
  
}